import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    title: null,
    body: null,
}

const snackErrorSlice = createSlice({
    name: 'errors',
    initialState,
    reducers: {
        setSnackError: (state, action) => {
            state.title = action.payload.title
            state.body = action.payload.body
        }
    }
})

export const { setSnackError } = snackErrorSlice.actions;
export default snackErrorSlice.reducer;